import TotalSize from './TotalSize';

export default TotalSize;
